/** Ownership of existing triggers; tenant enablement remains in tenant config. */
export function workflowTriggerModule(event: string): string | undefined {
  if (event.startsWith("payroll_")) return "payroll";
  if (event.startsWith("salary_")) return "salary";
  if (event.startsWith("survey_")) return "surveys";
  return undefined;
}

export function workflowActionModule(action: string): string | undefined {
  if (action === "update_salary") return "salary";
  if (action === "create_payroll_adjustment") return "payroll";
  if (["publish_survey", "assign_survey_to_employee"].includes(action)) return "surveys";
  return undefined;
}
